import { render, staticRenderFns } from "./CustomPublicSettingTable.vue?vue&type=template&id=06fd3685&lang=pug"
import script from "./CustomPublicSettingTable.vue?vue&type=script&lang=ts"
export * from "./CustomPublicSettingTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports